// extracted by mini-css-extract-plugin
export default {"wrapper":"ChatContent_wrapper__h98sB"};